export default __webpack_public_path__ + "static/media/lancement_jeu_compressed.7b1e6d16.mp4";